import axios from "axios"
// import { useSelector } from "react-redux"
import { store } from "../store"
import { CREATE_NOTES_ERROR, CREATE_NOTES_LOADING, CREATE_NOTES_SUCCESS, DELETE_NOTES_ERROR, DELETE_NOTES_LOADING, DELETE_NOTES_SUCCESS, GET_NOTES_ERROR, GET_NOTES_LOADING, GET_NOTES_SUCCESS, UPDATE_NOTES_ERROR, UPDATE_NOTES_LOADING, UPDATE_NOTES_SUCCESS } from "./note_types"
import { BASE_URL } from "../../constants/config"
import { LOGOUT } from "../users/user_types"

import {toast , Toaster } from 'react-hot-toast';



export const getNotes = (filtro)=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: GET_NOTES_LOADING})

    //console.log(" getNotes filtro => ",filtro);
    //console.log(" getNotes filtro => ");
    

    try {
        const res = await axios(BASE_URL+`/note?` + new URLSearchParams(filtro), {
            method: "get",
            headers: {
                Authorization: token
            }
        })
        const {status, message, data} = res.data

        // console.log( " RES DATA => ",data)
        // console.log( " STATUS => ",status)        

        if(status === 1){            
            dispatch({type: GET_NOTES_SUCCESS, payload: data})
        }else if(status === 2)
        dispatch({type: LOGOUT})
        else {
            toast.error(" Error cargando notas. "+message)
            dispatch({type: GET_NOTES_ERROR})
        }
    } catch (error) {      
        toast.error("Error en la conexión");
        dispatch({type: GET_NOTES_ERROR})
    }
}

export const createNotes = (obj)=>async(dispatch)=>{
    
    
    const {token} = store.getState().userReducer
    dispatch({type: CREATE_NOTES_LOADING})
    try {
        
        const res = await axios(BASE_URL+"/note/create", {
            method: "post",
            data: obj,
            headers: {
                Authorization: token
            }
        })
        const {status, message} = res.data

        console.log(status);
        if(status === 1)
        {
            toast.success(" Nota creada correctamente ")
            dispatch({type: CREATE_NOTES_SUCCESS})
            dispatch(getNotes())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else {
            toast.error(' Error al crear la nota. '+message)
            // alert(' Error al crear la nota. '+message)
                dispatch({type: CREATE_NOTES_ERROR})
        }
    } catch (error) {
        toast.error(' Error al crear la nota, vuelve a probarlo. ')
        dispatch({type: CREATE_NOTES_ERROR})
    }
}

export const updateNotes = (id, obj,filtros)=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: UPDATE_NOTES_LOADING})
    try {

        //console.log(" updateNotes => ",obj);
        console.log(" filtros => ",filtros);
        

        const res = await axios(BASE_URL+"/note/", {
            method: "patch",
            data: obj,
            headers: {
                Authorization: token,
                id: id
            }
        })
        const {status, message} = res.data
        if(status === 1)
        {
            toast.success(" Nota modificada correctamente. ")
            dispatch({type: UPDATE_NOTES_SUCCESS})
            dispatch(getNotes(filtros))
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else {
            toast.error(" Error al actualizar la nota. "+message)
            dispatch({type: UPDATE_NOTES_ERROR})
        }
    } catch (error) {
        dispatch({type: UPDATE_NOTES_ERROR})
    }
}

export const deleteNotes = (id)=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: DELETE_NOTES_LOADING})
    try {
        const res = await axios(BASE_URL+"/note/", {
            method: "delete",
            headers: {
                Authorization: token,
                id: id
            }
        })
        const {status, message} = res.data
        if(status ===1)
        {
            dispatch({type: DELETE_NOTES_SUCCESS})
            dispatch(getNotes())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error Borrando Nota "+message)
            dispatch({type: DELETE_NOTES_ERROR})
        }
    } catch (error) {
        dispatch({type: DELETE_NOTES_ERROR})
    }
}